import React, { useState } from "react";
import { Button, Card, CardBody, CardHeader, CardTitle, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import Select from "react-select";
import { Table } from "antd";
import "./index.css";
import { useMutation, useQuery } from "@tanstack/react-query";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { getUserMarketplaceList, getCatalogueListByUserMarketplaceId } from "services/dataservice";
import { useHistory, useLocation } from "react-router-dom";
import { editSplitInventory } from "services/dataservice";
import { getSplitInventoryByCatalogueId } from "services/dataservice";

const baseColumn = [
  {
    title: "#",
    key: "index",
    render: (value, record, index) => index + 1,
  },
  {
    title: "Marketplace Name",
    key: "1",
    dataIndex: "marketplaceName",
  },
  {
    title: "Inventory SKU",
    key: "2",
    dataIndex: "inventorySKU",
  },
  {
    title: "Name",
    key: "3",
    dataIndex: "name",
  },
  {
    title: "Available Quantity",
    key: "4",
    dataIndex: "quantity",
  },
];

export default function SplitInventoryEdit() {
  const history = useHistory();
  const location = useLocation();
  let { catalogueId } = location?.state ?? 0;
  catalogueId = catalogueId === undefined ? 0 : catalogueId;
  const [marketplaces, setMarketplaces] = useState([]);
  const [alert, setAlert] = useState(null);
  const [catalogues, setCatalogues] = useState([]);
  const [splitInv, setSplitInv] = useState({
    //userMarketplace: { id: 0, name: "" },
    userMarketplaces: [],
    criteria: "LOCK",
    lockQty: 0,
    reserveQty: 0,
    bufferQty:0
  });
  const [loadSKU, setLoadSKU] = useState(false);
  function getCriteria() {
    const { lockQty, reserveQty,bufferQty } = splitInv;
    if (lockQty === 0 && reserveQty === 0 && bufferQty===0) return "";
    if (lockQty !== 0 && reserveQty === 0 && bufferQty === 0) return "LOCK";
    if (lockQty === 0 && reserveQty !== 0 && bufferQty === 0) return "RESERVE";
    if (lockQty === 0 && reserveQty === 0 && bufferQty !== 0) return "BUFFER";
  }
  const criteria = getCriteria();
  const showSuccess = (msg, callBack = null) => {
    setAlert(
      <ReactBSAlert
        success
        style={{ display: "block" }}
        title={msg}
        onConfirm={() => (callBack == null ? setAlert(null) : callBack())}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="info"></ReactBSAlert>
    );
  };

  const showFail = (msg) => {
    setAlert(
      <ReactBSAlert
        danger
        style={{ display: "block", marginTop: "-100px" }}
        title={msg}
        onConfirm={() => setAlert(null)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="info"
        btnSize=""></ReactBSAlert>
    );
  };
  const onError = (data) => {
    try {
      const { message } = data.response.data;
      showFail(message);
    } catch (error) {
      showFail(error.response);
    }
  };
  const userMarketplaceIds = splitInv.userMarketplaces.map((x) => x.value);
  useQuery({
    queryKey: ["user-marketplace-list"],
    queryFn: () => getUserMarketplaceList(),
    onSuccess: (data) => setMarketplaces(data.data.data),
    onError,
  });
  // useQuery({
  //   queryKey: ["user-marketplace-list"],
  //   queryFn: () => getUserMarketplaceList(),
  //   onSuccess: (data) => setMarketplaces(data.data.data),
  //   onError: () => {},
  // });
  const{isFetching}=useQuery({
    queryKey: ["catalogues"],
    queryFn: () => getCatalogueListByUserMarketplaceId({ userMarketplaceIds, type: "Edit" }),

    //enabled: userMarketplaceId !== undefined,
    enabled: loadSKU,
    onSuccess: (data) => {
      setCatalogues(data.data.data);
      setLoadSKU(false);
    },
    onError,
  });

  useQuery({
    queryKey: ["catalogue"],
    queryFn: () => getSplitInventoryByCatalogueId({ catalogueId }),
    enabled: catalogueId !== 0,
    onSuccess: (data) => setDataSource(data.data.data),
    onError,
  });

  const [dataSource, setDataSource] = useState([]);
  // const onStoreChange = (value) => setSplitInv({ ...splitInv, userMarketplace: { id: value.value, name: value.label } });

  const onStoreChange = (value) => {
    if (value === null) {
      setSplitInv({ ...splitInv, userMarketplaces: [] });
    } else {
      setSplitInv({ ...splitInv, userMarketplaces: value });
    }
  };

  const onQuantityChange = (e, prop) => {
    const { value } = e.target;
    const updatedValue = Number(value);
    if (updatedValue < 0) return;
    if (prop === "lockQty") {
      if (splitInv.reserveQty > 0 || splitInv.bufferQty >0) return;
      if (updatedValue > 100) return;
      setSplitInv({ ...splitInv, lockQty: updatedValue });
      const newDataSource = dataSource.map((x) => {
        if (x.reserveQty > 0 || x.bufferQty > 0) return { ...x };
        return { ...x, lockQty: updatedValue };
      });
      if (newDataSource.length > 0) setDataSource(newDataSource);
    } else if(prop === "reserveQty") {
      if (splitInv.lockQty > 0 || splitInv.bufferQty >0) return;
      setSplitInv({ ...splitInv, reserveQty: updatedValue });
      const newDataSource = dataSource.map((x) => {
        if (x.lockQty > 0 || x.bufferQty > 0) return { ...x };
        return { ...x, reserveQty: x.allowCreateReserve ? updatedValue : 0 };
      });
      if (newDataSource.length > 0) setDataSource(newDataSource);
    }else{
      if (splitInv.lockQty > 0||splitInv.reserveQty > 0) return;
      setSplitInv({ ...splitInv, bufferQty: updatedValue });
      const newDataSource = dataSource.map((x) => {
        if (x.lockQty > 0 || x.reserveQty > 0) return { ...x };
        return { ...x, bufferQty: x.allowCreateReserve ? updatedValue : 0 };
      });
      if (newDataSource.length > 0) setDataSource(newDataSource);
    }
  };

  const onColumnQuantityChange = ({ target }, record) => {
    const { value } = target;
    const updatedValue = Number(value);
    if (updatedValue < 0) return;

    const newDataSource = [...dataSource];
    const index = dataSource.findIndex((x) => x.key === record.key);
    const rows = newDataSource[index];
    if (target.name === "lockQty") {
      if (splitInv.reserveQty > 0) return;
      if (updatedValue > 100) return;
      newDataSource.splice(index, 1, { ...rows, lockQty: updatedValue });
    } else if(target.name === "reserveQty") {
      if (splitInv.lockQty > 0) return;
      newDataSource.splice(index, 1, { ...rows, reserveQty: updatedValue });
    }
    else{
      newDataSource.splice(index, 1, { ...rows, bufferQty: updatedValue });
    } 
    setDataSource(newDataSource);
  };

  const columns = [
    ...baseColumn,
    {
      title: "Lock (%)",
      key: "5",
      dataIndex: "lockQtyBalance"
    },
    {
      title: "Edit Lock (%)",
      key: "6",
      dataIndex: "lockQty",
      render: (value, record) => <Input type="number" name="lockQty" value={value} onChange={(e) => onColumnQuantityChange(e, record)} disabled={(record.reserveQty > 0 || record.bufferQty >0) ? true : false} />,
    },
    {
      title: "Lock Qty (Balance)",
      key: "7",
      dataIndex: "reserveQtyBalance"
    },
    {
      title: "Edit Lock Qty",
      key: "8",
      dataIndex: "reserveQty",
      render: (value, record) => (
        <Input type="number" name="reserveQty" value={value} onChange={(e) => onColumnQuantityChange(e, record)} disabled={(!record.allowCreateReserve || record.lockQty > 0 || record.bufferQty > 0) ? true : false} />
      ),
    },
    {
      title: "Reserve Qty",
      key: "9",
      dataIndex: "bufferQtyBalance"
    },
    {
      title: "Edit Buffer Qty",
      key: "10",
      dataIndex: "bufferQty",
      render: (value, record) => <Input type="number" name="bufferQty" value={value} onChange={(e) => onColumnQuantityChange(e, record)} disabled={(record.reserveQty > 0 || record.lockQty > 0) ? true : false} />,
    },
    {
      title: "Action",
      key: "11",
      render: (value, record) => (
        <Button
          size="sm"
          className="btn-icon btn-link remove"
          color="danger"
          onClick={() => {
            const newDataSource = dataSource.filter((x) => x.key !== record.key);
            setDataSource(newDataSource);
          }}>
          <i className="fa fa-times" />
        </Button>
      ),
    },
  ];
  const editMutation = useMutation(editSplitInventory, { onError });

  const isSubmit = editMutation.status === "loading";

  const onSubmit = () => {
    let errMsg = "";
    const isValid = dataSource.some((x) => {
      // if (x.lockQty === 0 && x.reserveQty === 0 && x.bufferQty ===0) {
      //   errMsg = `${x.inventorySKU} 0 quantity`;
      //   return true;
      // }
      if (x.lockQty > 0 && x.reserveQty > 0) {
        errMsg = `${x.inventorySKU} cannot set lock and reserve`;
        return true;
      }
      if (x.reserveQty > x.quantity) {
        errMsg = `${x.inventorySKU} reserve quantity cannot greater than available quantity`;
        return true;
      }
      // if (criteria === "LOCK") {
      //   return x.lockQty === 0;
      // } else if (criteria === "RESERVE") {
      //   return x.reserveQty === 0;
      // }
    });
    if (isValid) {
      showFail(errMsg);
      return;
    }
    const list = dataSource.map((x) => {
      return {
        userMarketplaceId: x.userMarketplaceId,
        inventorySKU: x.inventorySKU,
        reserveQty: x.reserveQty,
        lockQty: x.lockQty,
        bufferQty:x.bufferQty,
        quantity:x.quantity,
        allowCreateReserve: x.allowCreateReserve,
      };
    });
    const splitInventoryList = JSON.stringify(list);
    editMutation.mutate(
      { splitInventoryList },
      {
        onSuccess: (data) => {
          showSuccess(data.data.message, () => history.push("/admin/split-inventory/list"));
        },
      }
    );
  };

  const Loading = ({msg}) =>
    <ReactBSAlert
      info
      style={{ display: "block", marginTop: "-100px" }}
      title={msg} 
      onConfirm={()=>{}}
      showConfirm={false}
      btnSize=""></ReactBSAlert>

  return (
    <div className="content">
      <Row>
        {alert}
        {isFetching && <Loading msg="Loading ..."/>}
        <Col md="12">
          <Form>
            <CardLayout title={"Edit Split Inventory"}>
              <Row>
                <Col>
                  <FormGroup>
                    <Label>Sales Channel Store</Label>
                    {/* <Select
                      className="react-select info"
                      classNamePrefix="react-select form-control"
                      value={{ value: splitInv.userMarketplace.id, label: splitInv.userMarketplace.name }}
                      options={marketplaces}
                      onChange={(value) => onStoreChange(value)}
                    /> */}
                    <Select
                      className="react-select info"
                      classNamePrefix="react-select form-control"
                      value={splitInv.userMarketplaces}
                      options={marketplaces}
                      onChange={(value) => onStoreChange(value)}
                      isMulti
                    />
                    {/* <Input type="text" value={userMarketplaceId?.toString()} disabled={true} /> */}
                  </FormGroup>
                  <Button onClick={() => setLoadSKU(!loadSKU)} disabled={splitInv.userMarketplaces.length === 0 ? true : false}>
                    Load SKU
                  </Button>
                </Col>

                <Col>
                  <FormGroup>
                    <Label>Lock (%)</Label>
                    <Input type="number" name="lockQty" min={0} max={100} value={splitInv.lockQty} onChange={(e) => onQuantityChange(e, "lockQty")} disabled={criteria === "RESERVE" || criteria === "BUFFER" ? true : false} />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label>Lock Quantity - Apply to all</Label>
                    <Input type="number" name="reserveQty" min={0} value={splitInv.reserveQty} onChange={(e) => onQuantityChange(e, "reserveQty")} disabled={criteria === "LOCK" || criteria === "BUFFER" ? true : false} />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label>Reserve Quantity - Apply to all</Label>
                    <Input type="number" name="bufferQty" min={0}  value={splitInv.bufferQty} onChange={(e) => onQuantityChange(e, "bufferQty")} disabled={criteria === "RESERVE" || criteria === "LOCK" ? true : false} />
                  </FormGroup>
                </Col>
              </Row>
            </CardLayout>

            <CardLayout title={"Inventory SKU List"}>
              <SKUList catalogues={catalogues} splitInv={splitInv} dataSource={dataSource} setDataSource={setDataSource} />
            </CardLayout>
            <CardLayout title={<><span>Selected Inventory SKU List</span><span style={{marginLeft:"3rem",fontWeight:"bold",fontSize:"1rem"}}>Available Quantity = OnHand + Lock/Reserve Balance</span></>}>
              <Table className="lock" columns={columns} dataSource={dataSource} />
              <Button color="info" onClick={onSubmit} disabled={dataSource.length === 0 || isSubmit}>
                {isSubmit ? "Submitting" : "Submit"}
              </Button>
            </CardLayout>
          </Form>
        </Col>
      </Row>
    </div>
  );
}

const CardLayout = ({ children, title }) => (
  <Card>
    <CardHeader>
      <CardTitle tag="h4">{title}</CardTitle>
    </CardHeader>
    <CardBody>{children}</CardBody>
  </Card>
);

const SKUList = ({ catalogues, dataSource, setDataSource }) => {
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [selected, setSelected] = useState([]);
  const [searchText, setSearchText] = useState("");
  const rowSelection = {
    selectedRowKeys: selectedKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedKeys(selectedRowKeys);
      setSelected(selectedRows);
    },
    //getCheckboxProps:(record)=>({inventorySKU:record.inventorySKU})
  };
  const onAdd = () => {
    if (selected.length === 0) return;
    const isDuplicate = dataSource.some((x) => selectedKeys.includes(x.key));
    if (isDuplicate) return;
    const newDataSource = selected;
    setDataSource([...dataSource, ...newDataSource]);
    setSelected([]);
    setSelectedKeys([]);
  };

  const columns = [
    {
      title: "Marketplace Name",
      dataIndex: "marketplaceName",
    },
    {
      title: "Inventory SKU",
      dataIndex: "inventorySKU",
      filteredValue: [searchText],
      onFilter: (value, record) => String(record.inventorySKU).toLowerCase().includes(value.toLowerCase()) || String(record.name).toLowerCase().includes(value.toLowerCase()),
    },
    { title: "Name", dataIndex: "name" },
    { title: "Available Quantity", dataIndex: "quantity" },
    {
      title: "Lock (%)",
      dataIndex: "lockQty",
    },
    {
      title: "Lock Qty",
      dataIndex: "reserveQty",
    },
    {
      title: "Reserve Qty",
      dataIndex: "bufferQty",
    },
  ];
  return (
    <>
      <FormGroup>
        <Input type="text" placeholder="search sku or name" onChange={({ target }) => setSearchText(target.value)} />
      </FormGroup>

      <Table
        className="list"
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        columns={columns}
        dataSource={catalogues}
      />
      <Button color="info" onClick={onAdd} disabled={selected.length === 0}>
        Add To Selected SKU List
      </Button>
    </>
  );
};
